<div *ngIf="canView()">
  <p *ngIf="form['error'] == false && form['message']">
    <app-ncs-alert [message]="form['message']" type="success" />
  </p>
  <p *ngIf="form['error'] == true && form['message']">
    <app-ncs-alert [message]="form['message']" type="danger" />
  </p>

  <form #uiForm="ngForm" class="row g-3 mb-3 compact-inputs">
    <!-- Row 1: Dropdowns -->
    <div class="col-12">
      <div class="row g-3 align-items-center">
        <div class="col-lg-4 col-md-6">
          
          <mat-form-field
            appearance="outline"
            class="w-100 compact-form-field validation-field dropdown-pd-none"
          >
            <mat-label>{{
              "roleAccess.form.selectors.role" | translate
            }}</mat-label>
            <mat-select
              name="applicationRoleId"
              [(ngModel)]="form.data['applicationRoleId']"
              required
              (selectionChange)="convertStringToNumber('applicationRoleId')"
              #applicationRoleId="ngModel"
            >
              <mat-option disabled [value]="undefined">
                {{ "roleAccess.form.selectors.role" | translate }}
              </mat-option>
              <mat-option *ngFor="let c of applicationsroles" [value]="c.id">
                {{ c.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-lg-4 col-md-6">
          <mat-form-field
            appearance="outline"
            class="w-100 compact-form-field validation-field dropdown-pd-none"
          >
            <mat-label>{{
              "roleAccess.form.selectors.usecase" | translate
            }}</mat-label>
            <mat-select
              name="apiId"
              [(ngModel)]="form.data['apiId']"
              required
              (selectionChange)="getForms(form.data['apiId'])"
              #apiId="ngModel"
            >
              <mat-option disabled [value]="undefined">
                {{ "roleAccess.form.selectors.usecase" | translate }}
              </mat-option>
              <mat-option *ngFor="let c of usecases" [value]="c.id">
                {{ c.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-lg-4 col-md-12">
          <mat-form-field
            appearance="outline"
            class="w-100 compact-form-field validation-field dropdown-pd-none"
          >
            <mat-label>{{
              "roleAccess.form.selectors.form" | translate
            }}</mat-label>
            <mat-select
              name="formId"
              [(ngModel)]="form.data['formId']"
              required
              (selectionChange)="convertStringToNumber('formId')"
              #formId="ngModel"
            >
              <mat-option disabled [value]="undefined">
                {{ "roleAccess.form.selectors.form" | translate }}
              </mat-option>
              <mat-option *ngFor="let c of forms" [value]="c.id">
                {{ c.title }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>

    <!-- Row 2: Checkboxes -->
    <div
      class="col-lg-9 col-md-12 d-flex flex-wrap align-items-center gap-2 ps-0"
    >
      <div class="d-flex align-items-center me-2">
        <mat-checkbox
          color="primary"
          id="create"
          name="create"
          [(ngModel)]="form.data['create']"
          (change)="convertBooleanToNumber('create')"
          class="me-1"
        ></mat-checkbox>
        <label for="create" class="form-check-label mb-0">
          {{ "roleAccess.form.permissions.create" | translate }}
        </label>
      </div>

      <div class="d-flex align-items-center me-2">
        <mat-checkbox
          color="primary"
          id="update"
          name="update"
          [(ngModel)]="form.data['update']"
          (change)="convertBooleanToNumber('update')"
          class="me-1"
        ></mat-checkbox>
        <label for="update" class="form-check-label mb-0">
          {{ "roleAccess.form.permissions.update" | translate }}
        </label>
      </div>

      <div class="d-flex align-items-center me-2">
        <mat-checkbox
          color="primary"
          id="read"
          name="read"
          [(ngModel)]="form.data['read']"
          (change)="convertBooleanToNumber('read')"
          class="me-1"
        ></mat-checkbox>
        <label for="read" class="form-check-label mb-0">
          {{ "roleAccess.form.permissions.read" | translate }}
        </label>
      </div>

      <div class="d-flex align-items-center me-2">
        <mat-checkbox
          color="primary"
          id="delete"
          name="delete"
          [(ngModel)]="form.data['delete']"
          (change)="convertBooleanToNumber('delete')"
          class="me-1"
        ></mat-checkbox>
        <label for="delete" class="form-check-label mb-0">
          {{ "roleAccess.form.permissions.delete" | translate }}
        </label>
      </div>

      <div class="d-flex align-items-center me-2">
        <mat-checkbox
          color="primary"
          id="userFilter"
          name="userFilter"
          [(ngModel)]="form.data['userFilter']"
          (change)="convertBooleanToNumber('userFilter')"
          class="me-1"
        ></mat-checkbox>
        <label for="userFilter" class="form-check-label mb-0">
          {{ "roleAccess.form.permissions.userFilter" | translate }}
        </label>
      </div>
    </div>

    <!-- Row 3: Buttons and Error Message -->
    <div class="col-lg-3 col-md-12">
      <div
        class="d-flex justify-content-lg-end justify-content-md-start gap-2 mt-lg-0 mt-md-2"
      >
        <button
          mat-stroked-button
          color="primary"
          [title]="'roleAccess.form.buttons.save' | translate"
          [disabled]="uiForm.invalid || !canCreate()"
          (click)="save()"
        >
          <mat-icon>save</mat-icon>
          <span class="ms-1">{{
            "roleAccess.form.buttons.save" | translate
          }}</span>
        </button>

        <button
          *ngIf="canCreate()"
          mat-stroked-button
          color="primary"
          [title]="'roleAccess.form.buttons.addNew' | translate"
          (click)="resetForm()"
        >
          <mat-icon>add</mat-icon>
          <span class="ms-1">{{
            "roleAccess.form.buttons.addNew" | translate
          }}</span>
        </button>
      </div>

      <!-- Error Message -->
      <div class="mt-2 text-end">
        <span class="text-danger">{{
          form.inputerror["applicationRoleId"]
        }}</span>
      </div>
    </div>
  </form>

  <!-- Table -->
  <div class="table-container mb-2">
    <div class="table-responsive table-scrollable">
      <table class="table table-bordered table-hover table-sticky-header">
        <thead>
          <tr>
            <th>{{ "roleAccess.table.headers.sno" | translate }}</th>
            <th class="text-nowrap sortable-header">
              <span class="header-label">
                {{ "roleAccess.table.headers.applicationRole" | translate }}
              </span>
            </th>
            <th class="text-nowrap sortable-header">
              <span class="header-label">
                {{ "roleAccess.table.headers.usecase" | translate }}
              </span>
            </th>
            <th class="text-nowrap sortable-header">
              <span class="header-label">
                {{ "roleAccess.table.headers.form" | translate }}
              </span>
            </th>
            <th class="text-nowrap sortable-header">
              <span class="header-label">
                {{ "roleAccess.table.headers.create" | translate }}
              </span>
            </th>
            <th class="text-nowrap sortable-header">
              <span class="header-label">
                {{ "roleAccess.table.headers.update" | translate }}
              </span>
            </th>
            <th class="text-nowrap sortable-header">
              <span class="header-label">
                {{ "roleAccess.table.headers.read" | translate }}
              </span>
            </th>
            <th class="text-nowrap sortable-header">
              <span class="header-label">
                {{ "roleAccess.table.headers.delete" | translate }}
              </span>
            </th>
            <th class="text-nowrap sortable-header">
              <span class="header-label">
                {{ "roleAccess.table.headers.userFilter" | translate }}
              </span>
            </th>
            <th class="text-end">
              {{ "roleAccess.table.headers.action" | translate }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let e of form.list; let i = index">
            <td class="text-center">{{ pageIndex(i) }}</td>
            <td>{{ e["applicationRoleName"] }}</td>
            <td>{{ e["apiName"] }}</td>
            <td>{{ e["formTitle"] }}</td>
            <td>
              {{
                e["create"] == 1
                  ? ("roleAccess.table.values.yes" | translate)
                  : ("roleAccess.table.values.no" | translate)
              }}
            </td>
            <td>
              {{
                e["update"] == 1
                  ? ("roleAccess.table.values.yes" | translate)
                  : ("roleAccess.table.values.no" | translate)
              }}
            </td>
            <td>
              {{
                e["read"] == 1
                  ? ("roleAccess.table.values.yes" | translate)
                  : ("roleAccess.table.values.no" | translate)
              }}
            </td>
            <td>
              {{
                e["delete"] == 1
                  ? ("roleAccess.table.values.yes" | translate)
                  : ("roleAccess.table.values.no" | translate)
              }}
            </td>
            <td>
              {{
                e["userFilter"] == 1
                  ? ("roleAccess.table.values.yes" | translate)
                  : ("roleAccess.table.values.no" | translate)
              }}
            </td>

            <!-- Actions -->
            <td>
              <div
                class="d-flex align-items-center justify-content-center p-0 m-0"
              >
                <button
                  *ngIf="canDelete()"
                  mat-stroked-button
                  color="warn"
                  class="icon-center icon-clean icon-width"
                  [matTooltip]="'roleAccess.table.actions.delete' | translate"
                  (click)="delete(e.id)"
                >
                  <mat-icon class="icon-compact">delete</mat-icon>
                </button>

                <button
                  *ngIf="e['status'] === 'Accept'"
                  mat-stroked-button
                  color="warn"
                  class="icon-center icon-clean icon-width"
                  [matTooltip]="'roleAccess.table.actions.block' | translate"
                >
                  <mat-icon class="icon-compact">block</mat-icon>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="my-2 pt-1">
    <app-list-header [$parent]="getSelf()"></app-list-header>
  </div>
</div>

<div *ngIf="!canView()" class="alert alert-warning">
  {{ "roleAccess.messages.noPermission" | translate }}
</div>
